const apiUrl = process.env.REACT_APP_API
const storageUrl = process.env.REACT_APP_STORAGE

if (!apiUrl) {
  throw new Error('Missing REACT_APP_API in .env file (used for Axios baseURL)')
}

if (!storageUrl) {
  throw new Error('Missing REACT_APP_STORAGE in .env')
}

// Ensure trailing slashes are consistent (only one)
export const API_URL = apiUrl.replace(/\/?$/, '/')
export const STORAGE_URL = storageUrl.replace(/\/?$/, '/')
